import styles from './ui-menu-group.css';
import { Attribute } from '../../../decorators/attribute.decorator';
import { Children } from '../../../decorators/child.decorator';
import { Component } from '../../../decorators/component.decorator';
import { UIElement } from '../../ui-element';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIMenuGroup
 * @element ui-menu-group
 * @classdesc Represents a class for <code>ui-menu-group</code> element. Should be used inside <code>ui-menu-column</code> element.
 * @property {string} label {@attr label} - The label for the header of the menu group.
 * @example
 * <ui-menu-group label="Loans">
 *     <ui-menu-link>Small Loan</ui-menu-link>
 *     <ui-menu-link>Home Loan</ui-menu-link>
 *     <ui-menu-link>Car Loan</ui-menu-link>
 *     <ui-menu-link>Student Loan</ui-menu-link>
 * </ui-menu-group>
 */
@Component({
    tag: 'ui-menu-group',
    styles,
})
export class UIMenuGroup extends UIElement {
    @Attribute() label!: string;

    @Children('ui-menu-link') menuLinks?: Array<UIElement>;

    /**
     * @inheritDoc
     */
    render() {
        const label = this.createElement({
            tagName: 'span',
            classList: {
                'ui-menu-group__label': true,
            },
            children: [this.label],
        });
        this.prepend(label);
    }
}
